/**
 * Renvoie une URL d'image redimensionnée + convertie en WebP via le proxy
 * gratuit images.weserv.nl (libvips). Sert à délivrer en léger les photos
 * stockées en plein format dans Supabase Storage : la transformation d'images
 * native de Supabase n'est PAS activée sur ce projet (FeatureNotEnabled), donc
 * on passe par ce proxy côté affichage.
 *
 * - Ne proxifie QUE les URLs http(s) publiques (Supabase storage, etc.).
 * - Laisse intactes : images relatives, data:, blob:, et celles déjà proxifiées.
 * - weserv lit le vrai content-type (ok même si l'extension est .JPG en dur).
 *
 * Complémentaire à la compression à l'upload : à terme les fichiers stockés
 * seront déjà légers, mais ce proxy couvre aussi les anciennes images lourdes.
 */
// Domaine de PROD où sont servies les images relatives (/lovable-uploads/...).
// On absolutise vers CE domaine (et pas window.location.origin) : si l'utilisateur
// consulte le site via www. ou un domaine de preview, weserv — qui résout l'URL
// côté serveur — ne saurait pas atteindre cette origine, et le logo casserait.
const PROD_ORIGIN = 'https://maisoneridia.fr';

export function proxyImage(
  url: string | undefined | null,
  opts: { width: number; height?: number; quality?: number },
): string {
  const { width, height, quality = 72 } = opts;
  if (!url || url.includes('images.weserv.nl')) return url ?? '';

  // Absolutiser les URLs relatives (servies depuis notre domaine de prod).
  const absolute = url.startsWith('/') ? PROD_ORIGIN + url : url;
  if (!/^https?:\/\//i.test(absolute)) return url; // data:, blob: → tel quel
  if (/^https?:\/\/(localhost|127\.0\.0\.1)/i.test(absolute)) return url; // dev

  // En local (dev/preview), weserv ne peut pas atteindre localhost → pas de proxy.
  if (/^https?:\/\/(localhost|127\.0\.0\.1|\[?::1)/i.test(absolute)) return url;

  // On retire les éventuels query params de la source (ex. transforms Lovable
  // morts en prod, ?width=&format=webp ignorés) : weserv les ignorerait, et son
  // parsing casserait sur le '&'.
  const base = absolute.split('?')[0].replace(/^https?:\/\//i, '');
  const params = [`url=ssl:${base}`, `w=${width}`];
  if (height) params.push(`h=${height}`, 'fit=cover');
  params.push('output=webp', `q=${quality}`);
  return `https://images.weserv.nl/?${params.join('&')}`;
}
